import firebase from "firebase/app";
import "firebase/firestore";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";

import { AppThunk } from "services/redux/rootReducer";
import { Product } from "../../types/product";
import extractCombinedTagKeysFromProduct from "features/product/functions/extractCombinedTagKeysFromProduct";

const addOneProduct =
    (product: Product): AppThunk =>
    async (dispatch) => {
        const db = firebase.firestore();
        const docRef = db.collection("products").doc(product.id);
        const subCollectionRef = docRef.collection("tables");

        let tableIds: string[] = [];

        // add tables to subcollections
        await Promise.all(
            Object.values(product.tables).map(async (table) => {
                const docRef = subCollectionRef.doc();
                await docRef.set({
                    ...table,
                    id: docRef.id,
                });
                tableIds.push(docRef.id);
            })
        );

        // create combinedTags
        const combinedTags = extractCombinedTagKeysFromProduct(product);

        // remove property tables from product object
        const { tables, ...productWithoutTables } = product;

        await docRef.set({
            ...productWithoutTables,
            properties: {
                ...productWithoutTables.properties,
                creationTimestamp: Date.now(),
                updateTimestamp: Date.now(),
            },
            tableIds,
            combinedTags,
        } as Product);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added one product with id ${product.id}`,
                },
            })
        );

        return;
    };

export default addOneProduct;
